import { useRef, type ReactNode } from "react";
import { Button } from "./Button.js";
import { useDialogFocus } from "../hooks/useDialogFocus.js";

export interface DialogProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children?: ReactNode;
  actions?: ReactNode;
}

export function Dialog({ open, title, onClose, children, actions }: DialogProps) {
  const dialogRef = useRef<HTMLDivElement>(null);
  useDialogFocus({ open, onClose, rootRef: dialogRef });

  if (!open) return null;
  return (
    <div className="ui-dialog__overlay" onClick={onClose} role="presentation">
      <div ref={dialogRef} className="ui-dialog" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} onClick={(event) => event.stopPropagation()}>
        <h2 className="ui-dialog__title">{title}</h2>
        {children && <div className="ui-dialog__body">{children}</div>}
        <div className="ui-dialog__actions">
          {actions ?? <Button variant="ghost" onClick={onClose}>Close</Button>}
        </div>
      </div>
    </div>
  );
}
